<template>
  <div class="is-relative" style="min-height: 8rem;">
    <header>
      <slot name="header" v-bind="{ itemsTotal }"></slot>
      <!-- 
	   <b-pagination
	   v-if="pagesTotal > 1"
	   :total="itemsTotal"
	   :current.sync="currentPage"
	   :range-before="3"
	   :range-after="4"
	   order="is-right"
	   :per-page="itemsPerPage"
	   icon-prev="chevron-left"
	   icon-next="chevron-right">
	   </b-pagination>
      -->
    </header>
    <main>
      <slot v-bind="{ itemsTotal, items }"></slot>
    </main>
    <footer>
      <b-pagination
	v-if="pagesTotal > 1"
        :total="itemsTotal"
        :current.sync="currentPage"
        :range-before="3"
        :range-after="4"
        order="is-right"
        :per-page="itemsPerPage"
        icon-prev="chevron-left"
        icon-next="chevron-right">
      </b-pagination>
    </footer>
    <b-loading :active="isLoading" :is-full-page="false"></b-loading>
  </div>
</template>

<script>
 import { debounce } from '@/utils/misc.js'
 import { createMapper } from '@/utils/mapping.js'
 import { createValidator } from '@/utils/validation.js'
 
 const validator = createValidator('paginated')
 const mapper = createMapper('paginated')

 export default {
   props: {
     fetch: {
       type: Function,
       required: true
     },
     itemsPerPage: {
       type: Number,
       default: 10
     }
   },
   watch: {
     // NOTE: register this handler watcher for $route.query last, however maps are unordered
     '$route.query': {
       handler: function (newQuery, oldQuery) {
	 if (newQuery[this.pageParamName] != oldQuery[this.pageParamName]) {
	   const parsedValue = newQuery[this.pageParamName]
	   if (Number.isFinite(parsedValue)) {
	     // pagesTotal might be NaN
	     if (!Number.isFinite(this.pagesTotal)) {
	       this.currentPage = parsedValue
	     }
	     else {
	       this.currentPage = Math.max(1, Math.min(this.pagesTotal, parsedValue))
	     }
	   }
	   else {
	     // no url param provided, default to 1
	     this.currentPage = 1
	   }
	 }
       },
       immediate: true
     },
     'currentPage': {
       handler: function () {
	 const query = { ...this.$route.query }
	 if (this.currentPage == 1) {
	   delete query[this.pageParamName]
	 }
	 else {
	   query[this.pageParamName] = this.currentPage
	 }
	 this.$router.push({ query })
       }
     },
     '$route.query': {
       handler: 'tryToLoad'
     }
   },
   data() {
     return {
       total: NaN,
       isLoading: false,
       currentPage: 1,
       items: []
     }
   },
   computed: {
     canLoad() {
       return !this.isLoading && validator.isValid(this.query)
     },
     itemsTotal() {
       if (!Number.isInteger(this.total)) {
	 return null
       }
       else {
	 return this.total
       }
     },
     pagesTotal() {
       return Math.ceil(this.total / this.itemsPerPage)
     },
     offset() {
       return (this.currentPage - 1) * this.itemsPerPage
     },
     limit() {
       return this.itemsPerPage
     },
     params() {
       return { offset: this.offset, limit: this.limit }
     },
     pageParamName() {
       return mapper.toURL('page')
     }
   },
   async mounted() {
     await this.tryToLoad()
   },
   methods: {
     async tryToLoad() {
       if (this.canLoad) {
	 await this.load()
       }
     },
     load: debounce(async function load() {
       this.isLoading = true
       const data = await this.fetch(this.params)
       this.items = data.items
       this.total = data.total
       this.isLoading = false
       this.$emit('load')
     }, 50)
   }
 }
</script>
